
(function () {
  'use strict';

  var root = document.querySelector('[data-wli]');
  if (!root || document.documentElement.getAttribute('data-wl-intro') === '0') return;

  function bnDir(el) { return getComputedStyle(el || document.documentElement).direction === 'rtl' ? -1 : 1; }

  var SIGNIN_HEADING = 'Sign in to start your shelf';

  function signIn(event) {
    if (event) event.preventDefault();
    var opened = false;
    try {
      opened = !!(window.BNAccount && window.BNAccount.open(SIGNIN_HEADING));
    } catch (e) {
      opened = false;
    }
    if (!opened) {
      window.location.href =
        root.getAttribute('data-wli-login') || '/customer_authentication/login';
    }
  }

  var buttons = root.querySelectorAll('[data-wli-signin]');
  for (var b = 0; b < buttons.length; b++) {
    buttons[b].addEventListener('click', signIn);
  }

  var fan = root.querySelector('[data-wli-fan]');
  var art = root.querySelector('[data-wli-art]');
  var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var precise = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  if (fan && art && precise && !calm) {
    var LEAN = 6;
    var leanFrame = null;
    var leanX = 0;
    var leanY = 0;

    function writeLean() {
      leanFrame = null;
      fan.style.setProperty('--lean-x', leanX.toFixed(2) + 'px');
      fan.style.setProperty('--lean-y', leanY.toFixed(2) + 'px');
    }

    function queueLean() {
      if (leanFrame || !window.requestAnimationFrame) return;
      leanFrame = window.requestAnimationFrame(writeLean);
    }

    art.addEventListener('pointermove', function (e) {
      var r = art.getBoundingClientRect();
      if (!r.width || !r.height) return;
      leanX = ((e.clientX - r.left) / r.width - 0.5) * 2 * LEAN;
      leanY = ((e.clientY - r.top) / r.height - 0.5) * 2 * LEAN;
      queueLean();
    });

    art.addEventListener('pointerleave', function () {
      leanX = 0;
      leanY = 0;
      queueLean();
    });
  }

  var film = root.querySelector('[data-wli-film]');
  var chapters = Array.prototype.slice.call(root.querySelectorAll('[data-wli-chapter]'));
  if (!film || !chapters.length) return;

  var video = film.querySelector('[data-wli-video]');
  if (!video) return;

  var WIDE = '(min-width: 750px) and (hover: hover) and (pointer: fine)';
  var mq = window.matchMedia ? window.matchMedia(WIDE) : null;
  var cut = '';
  var inView = !window.IntersectionObserver;
  var manualPause = false;
  var playButton = root.querySelector('[data-wli-play]');
  var box = film.querySelector('[data-wli-box]');

  function autoPlay() {
    if (!inView || calm || manualPause || document.hidden) return;
    var p = video.play();
    if (p && typeof p['catch'] === 'function') p['catch'](function () {});
  }

  function labelPlayback() {
    if (!playButton) return;
    var label = video.paused ? 'Play demo' : 'Pause demo';
    playButton.setAttribute('data-state', video.paused ? 'paused' : 'playing');
    playButton.setAttribute('aria-label', label);
  }

  if (playButton) playButton.addEventListener('click', function () {
    manualPause = !video.paused;
    if (manualPause) video.pause();
    else {
      armed = true;
      applySrc();
      var p = video.play();
      if (p && typeof p['catch'] === 'function') p['catch'](function () {});
    }
  });

  function pick() {
    var want = (mq ? mq.matches : window.innerWidth >= 750) ? 'desktop' : 'mobile';
    if (want === cut) return false;

    var src = film.getAttribute('data-' + want + '-src');
    if (!src) return false;

    cut = want;
    var poster = film.getAttribute('data-' + want + '-poster');
    if (poster) {
      video.setAttribute('poster', poster);
      if (box) box.style.setProperty('--wli-poster', 'url("' + poster + '")');
    }

    var size = (film.getAttribute('data-' + want + '-size') || '').split('x');
    if (size.length === 2 && size[0] && size[1]) {
      video.setAttribute('width', size[0]);
      video.setAttribute('height', size[1]);
    } else {
      video.removeAttribute('width');
      video.removeAttribute('height');
    }
    film.setAttribute('data-cut', want);
    readCues();
    pending = src;
    applySrc();
    return true;
  }

  var armed = false;
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var pending = '';

  function applySrc() {
    if (!armed || !pending) return;
    video.preload = saveData ? 'metadata' : 'auto';
    video.setAttribute('src', pending);
    pending = '';
    try { video.load(); } catch (e) {}
    autoPlay();
  }

  var watching = false;

  function watchArm() {
    if (watching) return;
    watching = true;
    var wrap = film.closest('.page-wrapper');
    var oy = wrap ? getComputedStyle(wrap).overflowY : '';
    var arm = new IntersectionObserver(
      function (entries) {
        var near = false;
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) near = true;
        }
        if (!near) return;
        arm.disconnect();
        armed = true;
        applySrc();
      },
      { root: oy === 'auto' || oy === 'scroll' ? wrap : null, rootMargin: '1600px 0px' }
    );
    arm.observe(film);
  }

  if (window.IntersectionObserver) {
    if (document.readyState === 'complete') watchArm();
    else {
      window.addEventListener('load', watchArm);
      setTimeout(watchArm, 4000);
    }
  } else {
    armed = true;
  }

  var cues = [];

  function readCues() {
    cues = [];
    for (var i = 0; i < chapters.length; i++) {
      var n = parseFloat(chapters[i].getAttribute('data-t-' + (cut || 'desktop')));
      cues.push(isNaN(n) ? 0 : n);
    }
  }

  function cueOf(chapter) {
    var i = chapters.indexOf(chapter);
    return i >= 0 && cues.length ? cues[i] : 0;
  }

  function clock(seconds) {
    var s = Math.max(0, Math.round(seconds));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }

  function stampTimes() {
    for (var i = 0; i < chapters.length; i++) {
      var at = chapters[i].querySelector('[data-wli-at]');
      if (at) at.textContent = clock(cueOf(chapters[i]));
    }
  }

  function span(index) {
    var from = cues[index] || 0;
    var to = index + 1 < chapters.length
      ? (cues[index + 1] || 0)
      : (video.duration && isFinite(video.duration) ? video.duration : from + 1);
    if (!(to > from)) to = from + 1;
    return { from: from, to: to };
  }

  var strip = chapters[0].parentNode;
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function follow(index) {
    if (!strip || !chapters[index]) return;

    var slack = strip.scrollWidth - strip.clientWidth;
    if (slack < 8) return;

    var dm = bnDir(strip);
    var sr = strip.getBoundingClientRect();
    var cr = chapters[index].getBoundingClientRect();
    var at = Math.abs(strip.scrollLeft);
    var left = at + (dm === 1 ? cr.left - sr.left : sr.right - cr.right);
    if (left > slack) left = slack;
    if (left < 0) left = 0;

    if (Math.abs(at - left) < 4) return;

    try { strip.scrollTo({ left: left * dm, behavior: still ? 'auto' : 'smooth' }); }
    catch (e) { strip.scrollLeft = left * dm; }
  }

  var lastOn = -1;

  function paint() {
    var t = video.currentTime || 0;

    var on = 0;
    for (var i = 0; i < cues.length; i++) {
      if (t >= cues[i] - 0.05) on = i;
    }

    if (on !== lastOn) {
      for (var c = 0; c < chapters.length; c++) {
        chapters[c].classList.toggle('is-on', c === on);
        if (c === on) continue;
        var other = chapters[c].querySelector('[data-wli-bar]');
        if (other) other.style.width = '0%';
      }
      lastOn = on;
      follow(on);
    }

    var s = span(on);
    var pct = Math.min(100, Math.max(0, ((t - s.from) / (s.to - s.from)) * 100));
    var bar = chapters[on].querySelector('[data-wli-bar]');
    if (bar) bar.style.width = pct + '%';
  }

  var frame = null;

  function loop() {
    frame = null;
    if (video.paused || video.ended || document.hidden) return;
    paint();
    frame = window.requestAnimationFrame ? window.requestAnimationFrame(loop) : null;
  }

  function startLoop() {
    if (frame || video.paused || video.ended || document.hidden || !window.requestAnimationFrame) return;
    frame = window.requestAnimationFrame(loop);
  }

  function stopLoop() {
    if (!frame) return;
    window.cancelAnimationFrame(frame);
    frame = null;
  }

  video.addEventListener('play', startLoop);
  video.addEventListener('playing', startLoop);
  video.addEventListener('pause', stopLoop);
  video.addEventListener('play', labelPlayback);
  video.addEventListener('pause', labelPlayback);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { video.pause(); stopLoop(); }
    else autoPlay();
  });
  video.addEventListener('ended', stopLoop);

  video.addEventListener('seeked', paint);
  video.addEventListener('loadedmetadata', paint);
  if (!window.requestAnimationFrame) video.addEventListener('timeupdate', paint);

  function reveal() {
    var r = film.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var seen = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    if (seen >= Math.min(r.height, vh) * 0.72) return;
    try { film.scrollIntoView({ block: 'center', behavior: still ? 'auto' : 'smooth' }); }
    catch (e) { film.scrollIntoView(); }
  }

  for (var ch = 0; ch < chapters.length; ch++) {
    (function (chapter) {
      var btn = chapter.querySelector('button');
      if (!btn) return;
      btn.addEventListener('click', function () {
        manualPause = false;
        armed = true;
        applySrc();
        try { video.currentTime = cueOf(chapter); } catch (e) { return; }
        var p = video.play();
        if (p && typeof p['catch'] === 'function') p['catch'](function () {});
        paint();
        reveal();
      });
    })(chapters[ch]);
  }

  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (inView) autoPlay();
      else if (!video.paused) video.pause();
    }, { threshold: 0.15 }).observe(film);
  }

  function onBreak() {
    if (!pick()) return;
    lastOn = -1;
    stampTimes();
    paint();
  }

  if (mq) {
    if (mq.addEventListener) mq.addEventListener('change', onBreak);
    else if (mq.addListener) mq.addListener(onBreak);
  } else {
    var rt = null;
    window.addEventListener('resize', function () {
      if (rt) clearTimeout(rt);
      rt = setTimeout(onBreak, 220);
    });
  }

  pick();
  if (!cues.length) readCues();
  stampTimes();
  paint();
  labelPlayback();
})();
